module.exports = __webpack_public_path__ + "a5de6786f06f1deaa135accb7b661175.svg";